import { isUserAdmin, User } from "@jasper/shared";
import { UseAuth } from "../../contexts";
import { Alert, Button, Group, Paper, Stack, Text, Title } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";
import { useThreeShapeOAuth } from "../../hooks/useThreeShapeOAuth";
import { useDsCoreOAuth } from "../../hooks/useDsCoreOAuth";

export const SettingsPage = () => {
  const { user } = UseAuth();
  const { get3ShapeOAuthUrl } = useThreeShapeOAuth();
  const { getDsCoreOAuthUrl } = useDsCoreOAuth();

  if (!isUserAdmin(user as unknown as User)) {
    return (
      <Alert
        variant="light"
        color="red"
        title="Forbidden access"
        icon={<IconInfoCircle />}
      >
        <Text>{"You don't have the permission to access this page."}</Text>
      </Alert>
    );
  }

  return (
    <Stack>
      <Title order={1} mb="md">
        Settings
      </Title>
      <Stack>
        <Paper shadow="xs" p="xl">
          <Title order={2} mb="md">
            3Shape Communicate
          </Title>
          <Stack>
            <Group justify="space-between">
              <Text>
                Update the 3Shape token? This is needed if the token has expired
                or been revoked.
              </Text>
              <Button
                onClick={() =>
                  get3ShapeOAuthUrl().then(url => {
                    window.location.href = url;
                  })
                }
              >
                Update 3Shape Token
              </Button>
            </Group>
          </Stack>
        </Paper>
        <Paper shadow="xs" p="xl">
          <Title order={2} mb="md">
            DS Core
          </Title>
          <Stack>
            <Group justify="space-between">
              <Text>
                Update the DS Core token? This is needed if the token has
                expired or been revoked.
              </Text>
              <Button
                onClick={() =>
                  getDsCoreOAuthUrl()
                    .then(url => {
                      window.location.href = url;
                    })
                    // The back builds the URL: it fails when DS Core is
                    // disabled or misconfigured, say so instead of doing nothing
                    .catch(err =>
                      notifications.show({
                        title: "Error",
                        message: `Failed to start the DS Core login: ${err.message}`,
                        color: "red",
                      })
                    )
                }
              >
                Update DS Core Token
              </Button>
            </Group>
          </Stack>
        </Paper>
      </Stack>
    </Stack>
  );
};
